import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen [height:100dvh] bg-gray-50 overflow-hidden">
      {/* Sidebar — desktop: siempre visible, mobile: overlay */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setSidebarOpen(false)} />
          <div className="relative w-64 h-full [height:100dvh] animate-slide-in shadow-2xl">
            <Sidebar />
            <button onClick={() => setSidebarOpen(false)}
              className="absolute top-3 right-3 w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center text-white hover:bg-gray-700 z-50">
              <X size={16} />
            </button>
          </div>
        </div>
      )}

      <div className="flex-1 flex flex-col min-w-0">
        {/* Navbar con botón hamburguesa en mobile */}
        <header className="bg-white border-b border-gray-200 px-4 lg:px-6 py-3 flex items-center justify-between flex-shrink-0">
          <div className="flex items-center gap-3">
            <button onClick={() => setSidebarOpen(true)} aria-label="Abrir menú" className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg border border-gray-200 hover:bg-gray-100 active:bg-gray-200 text-gray-700 flex-shrink-0">
              <Menu size={20} className="text-gray-600" />
            </button>
            <Navbar />
          </div>
        </header>

        <main className="flex-1 relative overflow-hidden">
          <div className="h-full overflow-y-auto scrollbar-thin">
            <div className="max-w-7xl mx-auto p-4 lg:p-6">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
